import { createRouter, createWebHistory } from 'vue-router'
import { getToken } from '@/utils/tokenStorage'

import LoginLayout from '@/components/LoginLayout.vue'
import GestionTurnos from '@/views/GestionTurnos.vue'
import GestionUsuarios from '@/views/GestionUsuarios.vue'
import GestionFacturas from '@/views/GestionFacturas.vue'
import GestionCobros from '@/views/GestionCobros.vue'
import GestionCaja from '@/views/GestionCaja.vue'
import GestionBuzones from '@/views/GestionBuzones.vue'
// import EditEmployeesShifts from '@/components/turnos/EditEmployeesShifts.vue'
import ManageEmployees from '@/components/turnos/ManageEmployees.vue'
// import JobPositions from '@/components/turnos/JobPositions.vue'
import ViewShifts from '@/components/turnos/ViewShifts.vue'
import ViewShiftsAll from '@/components/turnos/ViewShiftsAll.vue'
import GestionTarjeta from '@/views/GestionTarjeta.vue'
import GestionMaestroTarjetas from '@/views/GestionMaestroTarjetas.vue'
import CajaArqueo from '@/views/CajaArqueo.vue'
import GestionPagosC from '@/views/GestionPagosC.vue'
import GestionPagosE from '@/views/GestionPagosE.vue'
import GestionPagosF from '@/views/GestionPagosF.vue'
import GestionPagosH from '@/views/GestionPagosH.vue'
import GestionVariables from '@/views/GestionVariables.vue'
import ManageShifts from '@/components/turnos/ManageShifts.vue'
const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/components/HomePage.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/caja/dashboard',
    name: 'Dashboard',
    component: () => import('@/components/dashboard/DashboardView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginLayout,
    meta: { requiresAuth: false }
  },
  {
    path: '/turnos',
    name: 'GestionTurnos',
    component: GestionTurnos,
    meta: { requiresAuth: true }
  },
  {
    path: '/usuarios',
    name: 'GestionUsuarios',
    component: GestionUsuarios,
    meta: { requiresAuth: true }
  },
  {
    path: '/maestro-tarjetas-credito',
    name: 'GestionMaestroTarjetas',
    component: GestionMaestroTarjetas,
    meta: { requiresAuth: true }
  },
  {
    path: '/caja/a',
    name: 'gestion-facturas',
    component: GestionFacturas,
    meta: { requiresAuth: true }
  },
  {
    path: '/caja/b',
    name: 'GestionCobros',
    component: GestionCobros,
    meta: { requiresAuth: true }
  },
  {
    path: '/caja/c',
    name: 'GestionPagos_c',
    component: GestionPagosC,
    meta: { requiresAuth: true }
  },
  {
    path: '/caja/d',
    name: 'GestionTarjeta',
    component: GestionTarjeta,
    meta: { requiresAuth: true }
  },
  {
    path: '/caja/e',
    name: 'GestionPagos_e',
    component: GestionPagosE,
    meta: { requiresAuth: true }
  },
  {
    path: '/caja/f',
    name: 'GestionPagos_f',
    component: GestionPagosF,
    meta: { requiresAuth: true }
  },
  {
    path: '/caja/g',
    name: 'GestionBuzones',
    component: GestionBuzones,
    meta: { requiresAuth: true }
  },
  {
    path: '/caja/h',
    name: 'GestionPagos_h',
    component: GestionPagosH,
    meta: { requiresAuth: true }
  },

  {
    path: '/caja/caja',
    name: 'GestionCaja',
    component: GestionCaja,
    meta: { requiresAuth: true }
  },
  {
    path: '/caja/arqueo',
    name: 'caja-arqueo',
    component: CajaArqueo,
    meta: { requiresAuth: true }
  },
  {
    path: '/turnos/asignar-turnos',
    name: 'EditEmployeesShifts',
    component: ManageShifts,
    // component: EditEmployeesShifts,
    meta: { requiresAuth: true }
  },
  {
    path: '/turnos/asignar-turnos/:puestoId',
    name: 'EditEmployeesShiftsByPosition',
    component: ManageShifts,
    meta: { requiresAuth: true },
    props: true
  },
  {
    path: '/turnos/gestionar-empleados',
    name: 'ManageEmployees',
    component: ManageEmployees,
    meta: { requiresAuth: true }
  },
  // {
  //   path: '/turnos/puestos-trabajo',
  //   name: 'JobPositions',
  //   component: JobPositions,
  //   meta: { requiresAuth: true }
  // },
  {
    path: '/config/iniciar-valores',
    name: 'GestionVariables',
    component: GestionVariables,
    meta: { requiresAuth: true }
  },
  {
    path: '/turnos/ver-turnos',
    name: 'ViewShifts',
    component: ViewShifts,
    meta: { requiresAuth: true }
  },
  {
    path: '/turnos/ver-turnos-todos',
    name: 'ViewShiftsAll',
    component: ViewShiftsAll,
    meta: { requiresAuth: true }
  },
  {
    path: '/turnos/ver-turnos-todos',
    name: 'ViewEditEmployeesShifts',
    component: ViewShiftsAll,
    // component: EditEmployeesShifts,
    meta: { requiresAuth: true }
  },
  {
    path: '/turnos/ver-turnos-todos/:puestoId',
    name: 'ViewEmployeesShiftsByPosition',
    component: ViewShiftsAll,
    meta: { requiresAuth: true },
    props: true
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const isAuthenticated = !!getToken()
  if (
    to.matched.some((record) => record.meta.requiresAuth) &&
    !isAuthenticated
  ) {
    next('/login')
  } else {
    next()
  }
})

export default router
